'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = exports.GAP_OPTS = exports.ALIGN_OPTS = exports.JUSTIFY_OPTS = exports.FLEX_OPTS = exports.WRAP_OPTS = exports.LAYOUT_OPTS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/require-default-props */


exports.default = withLayout;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _startCase = require('lodash/startCase');

var _startCase2 = _interopRequireDefault(_startCase);

var _responsiveProp = require('../../lib/responsiveProp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'screen-small': '(max-width: 539px)',
  'screen-gt-small': '(min-width: 540px)',
  'screen-medium': '(max-width: 959px)',
  'screen-gt-medium': '(min-width: 960px)',
  'screen-large': '(max-width: 1247px)',
  'screen-gt-large': '(min-width: 1248px)',
  'screen-x-large': '(max-width: 1919px)',
  'screen-gt-x-large': '(min-width: 1920px)',
  'layout': 'tcl__withLayout-44ec86e8',
  'layoutInline': 'tcl__withLayout-fd261d97',
  'layoutHorizontal': 'tcl__withLayout-289bf27b',
  'layoutVertical': 'tcl__withLayout-4e97737c',
  'wrap': 'tcl__withLayout-6609b1b3',
  'wrapWrap': 'tcl__withLayout-94de2039',
  'wrapNowrap': 'tcl__withLayout-01c8f37b',
  'flex': 'tcl__withLayout-d960117d',
  'flexAuto': 'tcl__withLayout-88ac072c',
  'flexNone': 'tcl__withLayout-89a40b26',
  'flex1': 'tcl__withLayout-98d3e1bb',
  'flex2': 'tcl__withLayout-96789183',
  'flex3': 'tcl__withLayout-fcd07a3d',
  'flex4': 'tcl__withLayout-1ff32f4a',
  'flex5': 'tcl__withLayout-d5b6e465',
  'flex6': 'tcl__withLayout-ad0d818d',
  'flex7': 'tcl__withLayout-7c497e95',
  'flex8': 'tcl__withLayout-e0292665',
  'flex9': 'tcl__withLayout-e39cf864',
  'flex10': 'tcl__withLayout-3e23394e',
  'flex11': 'tcl__withLayout-8029990f',
  'flex12': 'tcl__withLayout-4f4f84bb',
  'justifyStart': 'tcl__withLayout-816ca8f5',
  'justifyCenter': 'tcl__withLayout-0c1dcdd7',
  'justifyEnd': 'tcl__withLayout-5faaebec',
  'justifyAround': 'tcl__withLayout-a87441e7',
  'justifyBetween': 'tcl__withLayout-def3aae6',
  'alignStart': 'tcl__withLayout-e7c265b5',
  'alignCenter': 'tcl__withLayout-c684a89b',
  'alignEnd': 'tcl__withLayout-a0b3a0b2',
  'layoutBlock': 'tcl__withLayout-f2998ff0',
  'layoutFit': 'tcl__withLayout-df8bad31',
  'tablet-layout': 'tcl__withLayout-533b5fb9',
  'tablet-layoutInline': 'tcl__withLayout-d3b07487',
  'tablet-layoutHorizontal': 'tcl__withLayout-bd3df970',
  'tablet-layoutVertical': 'tcl__withLayout-7161c607',
  'tablet-wrap': 'tcl__withLayout-ed8ceac5',
  'tablet-wrapWrap': 'tcl__withLayout-81fcffbb',
  'tablet-wrapNowrap': 'tcl__withLayout-2c7bc2de',
  'tablet-flex': 'tcl__withLayout-5efe9dc4',
  'tablet-flexAuto': 'tcl__withLayout-f0b3d1e1',
  'tablet-flexNone': 'tcl__withLayout-b536aa86',
  'tablet-flex1': 'tcl__withLayout-bed9f65b',
  'tablet-flex2': 'tcl__withLayout-c90f930d',
  'tablet-flex3': 'tcl__withLayout-eff11010',
  'tablet-flex4': 'tcl__withLayout-abbbc766',
  'tablet-flex5': 'tcl__withLayout-68213bed',
  'tablet-flex6': 'tcl__withLayout-49471c3a',
  'tablet-flex7': 'tcl__withLayout-c30d8c60',
  'tablet-flex8': 'tcl__withLayout-9b2bee20',
  'tablet-flex9': 'tcl__withLayout-640c69b3',
  'tablet-flex10': 'tcl__withLayout-a0424f4f',
  'tablet-flex11': 'tcl__withLayout-852e920f',
  'tablet-flex12': 'tcl__withLayout-71d0577b',
  'tablet-justifyStart': 'tcl__withLayout-328e22d3',
  'tablet-justifyCenter': 'tcl__withLayout-46e2a344',
  'tablet-justifyEnd': 'tcl__withLayout-824d4931',
  'tablet-justifyAround': 'tcl__withLayout-fa5071c1',
  'tablet-justifyBetween': 'tcl__withLayout-9109e04f',
  'tablet-alignStart': 'tcl__withLayout-7f49aeb9',
  'tablet-alignCenter': 'tcl__withLayout-a9fbfd2a',
  'tablet-alignEnd': 'tcl__withLayout-d1bfeb1e',
  'tablet-layoutBlock': 'tcl__withLayout-f84e7201',
  'tablet-layoutFit': 'tcl__withLayout-ba9ae7df',
  'desktop-layout': 'tcl__withLayout-e6572d8a',
  'desktop-layoutInline': 'tcl__withLayout-126d7324',
  'desktop-layoutHorizontal': 'tcl__withLayout-068f6d3a',
  'desktop-layoutVertical': 'tcl__withLayout-00eccfe0',
  'desktop-wrap': 'tcl__withLayout-3ac7862b',
  'desktop-wrapWrap': 'tcl__withLayout-e2c900a3',
  'desktop-wrapNowrap': 'tcl__withLayout-c7f920ed',
  'desktop-flex': 'tcl__withLayout-4704600c',
  'desktop-flexAuto': 'tcl__withLayout-f1ccca9b',
  'desktop-flexNone': 'tcl__withLayout-b779bd11',
  'desktop-flex1': 'tcl__withLayout-a2a9cf95',
  'desktop-flex2': 'tcl__withLayout-5fab4867',
  'desktop-flex3': 'tcl__withLayout-5e31c812',
  'desktop-flex4': 'tcl__withLayout-f2df2935',
  'desktop-flex5': 'tcl__withLayout-ec26b337',
  'desktop-flex6': 'tcl__withLayout-7d515438',
  'desktop-flex7': 'tcl__withLayout-bcee3cd8',
  'desktop-flex8': 'tcl__withLayout-51009900',
  'desktop-flex9': 'tcl__withLayout-b6b9cb2a',
  'desktop-flex10': 'tcl__withLayout-33778853',
  'desktop-flex11': 'tcl__withLayout-c4b0f286',
  'desktop-flex12': 'tcl__withLayout-7e69f5fb',
  'desktop-justifyStart': 'tcl__withLayout-bf842689',
  'desktop-justifyCenter': 'tcl__withLayout-f51ef292',
  'desktop-justifyEnd': 'tcl__withLayout-29103325',
  'desktop-justifyAround': 'tcl__withLayout-b08a9850',
  'desktop-justifyBetween': 'tcl__withLayout-9bcfb326',
  'desktop-alignStart': 'tcl__withLayout-3221abb6',
  'desktop-alignCenter': 'tcl__withLayout-7199cdd6',
  'desktop-alignEnd': 'tcl__withLayout-70586c60',
  'desktop-layoutBlock': 'tcl__withLayout-841db4a0',
  'desktop-layoutFit': 'tcl__withLayout-3ad56db3',
  'right-x-large': 'tcl__withLayout-0722f097',
  'top-x-large': 'tcl__withLayout-4394c0fc',
  'left-x-large': 'tcl__withLayout-7766b85c',
  'bottom-x-large': 'tcl__withLayout-bba5cf17',
  'horizontal-x-large': 'tcl__withLayout-581c7b34',
  'vertical-x-large': 'tcl__withLayout-9b2fd152',
  'all-x-large': 'tcl__withLayout-b6579d5d',
  'right-large': 'tcl__withLayout-7750e39c',
  'top-large': 'tcl__withLayout-352af0c8',
  'left-large': 'tcl__withLayout-e19f5559',
  'bottom-large': 'tcl__withLayout-dca40757',
  'horizontal-large': 'tcl__withLayout-2a4eb3f8',
  'vertical-large': 'tcl__withLayout-d406b68a',
  'all-large': 'tcl__withLayout-d1925954',
  'right-medium': 'tcl__withLayout-fae874e2',
  'top-medium': 'tcl__withLayout-536c8226',
  'left-medium': 'tcl__withLayout-012a45af',
  'bottom-medium': 'tcl__withLayout-eb8bfc6f',
  'horizontal-medium': 'tcl__withLayout-7464f9e1',
  'vertical-medium': 'tcl__withLayout-78fdcacd',
  'all-medium': 'tcl__withLayout-cac597e3',
  'right-small': 'tcl__withLayout-ed57c1c1',
  'top-small': 'tcl__withLayout-6589ea53',
  'left-small': 'tcl__withLayout-310b7fc0',
  'bottom-small': 'tcl__withLayout-dc916129',
  'horizontal-small': 'tcl__withLayout-4a0f7288',
  'vertical-small': 'tcl__withLayout-8994ac54',
  'all-small': 'tcl__withLayout-7a497ec6',
  'right-x-small': 'tcl__withLayout-b11a9d4d',
  'top-x-small': 'tcl__withLayout-18acbbf0',
  'left-x-small': 'tcl__withLayout-e13f82b0',
  'bottom-x-small': 'tcl__withLayout-2d9964d7',
  'horizontal-x-small': 'tcl__withLayout-43f87265',
  'vertical-x-small': 'tcl__withLayout-2b6b5fda',
  'all-x-small': 'tcl__withLayout-3af512b2',
  'tablet-right-x-large': 'tcl__withLayout-841fe0eb',
  'tablet-top-x-large': 'tcl__withLayout-919ec19a',
  'tablet-left-x-large': 'tcl__withLayout-917a1bb8',
  'tablet-bottom-x-large': 'tcl__withLayout-309403f0',
  'tablet-horizontal-x-large': 'tcl__withLayout-72d2fba2',
  'tablet-vertical-x-large': 'tcl__withLayout-71a57248',
  'tablet-all-x-large': 'tcl__withLayout-dde91d29',
  'tablet-right-large': 'tcl__withLayout-be9714a8',
  'tablet-top-large': 'tcl__withLayout-2d1d6708',
  'tablet-left-large': 'tcl__withLayout-269bb051',
  'tablet-bottom-large': 'tcl__withLayout-0ea6cab8',
  'tablet-horizontal-large': 'tcl__withLayout-920e6317',
  'tablet-vertical-large': 'tcl__withLayout-4d47a0b4',
  'tablet-all-large': 'tcl__withLayout-75b7ae51',
  'tablet-right-medium': 'tcl__withLayout-281b1b5b',
  'tablet-top-medium': 'tcl__withLayout-f3184efc',
  'tablet-left-medium': 'tcl__withLayout-cdbeb93e',
  'tablet-bottom-medium': 'tcl__withLayout-09bf0d5a',
  'tablet-horizontal-medium': 'tcl__withLayout-1a59128a',
  'tablet-vertical-medium': 'tcl__withLayout-b9dab366',
  'tablet-all-medium': 'tcl__withLayout-c92ddc35',
  'tablet-right-small': 'tcl__withLayout-72bd4b94',
  'tablet-top-small': 'tcl__withLayout-c10fcb27',
  'tablet-left-small': 'tcl__withLayout-ee8eb6d1',
  'tablet-bottom-small': 'tcl__withLayout-485de09e',
  'tablet-horizontal-small': 'tcl__withLayout-dd404804',
  'tablet-vertical-small': 'tcl__withLayout-0b5e6222',
  'tablet-all-small': 'tcl__withLayout-dc84e9c1',
  'tablet-right-x-small': 'tcl__withLayout-f81b1ff3',
  'tablet-top-x-small': 'tcl__withLayout-2cb0e81e',
  'tablet-left-x-small': 'tcl__withLayout-eed46011',
  'tablet-bottom-x-small': 'tcl__withLayout-ea33b260',
  'tablet-horizontal-x-small': 'tcl__withLayout-b97223d7',
  'tablet-vertical-x-small': 'tcl__withLayout-151aa5f6',
  'tablet-all-x-small': 'tcl__withLayout-540f2bf6',
  'desktop-right-x-large': 'tcl__withLayout-a7a09344',
  'desktop-top-x-large': 'tcl__withLayout-f442f372',
  'desktop-left-x-large': 'tcl__withLayout-cac7a10d',
  'desktop-bottom-x-large': 'tcl__withLayout-da2ab6be',
  'desktop-horizontal-x-large': 'tcl__withLayout-97821c54',
  'desktop-vertical-x-large': 'tcl__withLayout-bec4f81e',
  'desktop-all-x-large': 'tcl__withLayout-6b54a2db',
  'desktop-right-large': 'tcl__withLayout-ea94b6ff',
  'desktop-top-large': 'tcl__withLayout-dbfd1865',
  'desktop-left-large': 'tcl__withLayout-547d5670',
  'desktop-bottom-large': 'tcl__withLayout-1977a8e5',
  'desktop-horizontal-large': 'tcl__withLayout-3c6b62d0',
  'desktop-vertical-large': 'tcl__withLayout-1d7dbda4',
  'desktop-all-large': 'tcl__withLayout-d54c12c3',
  'desktop-right-medium': 'tcl__withLayout-5c495d19',
  'desktop-top-medium': 'tcl__withLayout-85f3ee57',
  'desktop-left-medium': 'tcl__withLayout-083b337b',
  'desktop-bottom-medium': 'tcl__withLayout-7c8c1b91',
  'desktop-horizontal-medium': 'tcl__withLayout-9256962c',
  'desktop-vertical-medium': 'tcl__withLayout-62871b36',
  'desktop-all-medium': 'tcl__withLayout-b5eedeec',
  'desktop-right-small': 'tcl__withLayout-7745dbe3',
  'desktop-top-small': 'tcl__withLayout-e3b7a3c6',
  'desktop-left-small': 'tcl__withLayout-28945454',
  'desktop-bottom-small': 'tcl__withLayout-4c7f4334',
  'desktop-horizontal-small': 'tcl__withLayout-166f947e',
  'desktop-vertical-small': 'tcl__withLayout-1dfcde7b',
  'desktop-all-small': 'tcl__withLayout-8bc0cf47',
  'desktop-right-x-small': 'tcl__withLayout-c36ef7e3',
  'desktop-top-x-small': 'tcl__withLayout-9ba4db0c',
  'desktop-left-x-small': 'tcl__withLayout-4f05da8c',
  'desktop-bottom-x-small': 'tcl__withLayout-29e354da',
  'desktop-horizontal-x-small': 'tcl__withLayout-3b7cab80',
  'desktop-vertical-x-small': 'tcl__withLayout-2b57745d',
  'desktop-all-x-small': 'tcl__withLayout-82b15802'
};
var LAYOUT_OPTS = exports.LAYOUT_OPTS = ['inline', 'horizontal', 'vertical', 'block', 'fit'];
var WRAP_OPTS = exports.WRAP_OPTS = ['wrap', 'nowrap'];
var FLEX_OPTS = exports.FLEX_OPTS = ['auto', 'none'];
var JUSTIFY_OPTS = exports.JUSTIFY_OPTS = ['start', 'center', 'end', 'around', 'between'];
var ALIGN_OPTS = exports.ALIGN_OPTS = ['start', 'center', 'end'];
var GAP_OPTS = exports.GAP_OPTS = ['x-large', 'large', 'medium', 'small', 'x-small'];

var defaultOptions = {
  /**
   * Do not forward layout props to Component. This makes is easier for the enhanced
   * component to forward all their props to built-in elements like <div> and <button>
   * without React warnings.
   */
  forwardLayoutProps: false
};

var toClassName = function toClassName(prop) {
  if (typeof prop === 'undefined') return '';
  if (typeof prop === 'boolean') return '';
  return (0, _startCase2.default)(prop);
};

var propTypes = exports.propTypes = {
  /**
   * Set component's 'display' and 'flex-direction' CSS properties. Setting it to true
   * simply displays flex.
   *
   * Use the object notation for a responsive layout (e.g. `{ mobile: 'vertical', tablet: 'horizontal' }`).
   */
  layout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(LAYOUT_OPTS), _propTypes2.default.bool, (0, _responsiveProp.responsivePropType)(_propTypes2.default.oneOfType([_propTypes2.default.oneOf(LAYOUT_OPTS), _propTypes2.default.bool]))]),

  /**
   * Set component's CSS 'flex-wrap' property.
   *
   * Use the object notation for a responsive layout (e.g. `{ mobile: true, tablet: false }`).
   */
  wrap: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(WRAP_OPTS), _propTypes2.default.bool, (0, _responsiveProp.responsivePropType)(_propTypes2.default.oneOfType([_propTypes2.default.oneOf(WRAP_OPTS), _propTypes2.default.bool]))]),

  /**
   * Set component's CSS 'flex' property. Setting a number defines the flex factor.
   * Setting it to true simply flexes.
   *
   * Use the object notation for a responsive layout (e.g. `{ mobile: true, tablet: 'none' }`).
   */
  flex: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(FLEX_OPTS), _propTypes2.default.number, _propTypes2.default.bool, (0, _responsiveProp.responsivePropType)(_propTypes2.default.oneOfType([_propTypes2.default.oneOf(FLEX_OPTS), _propTypes2.default.number, _propTypes2.default.bool]))]),

  /**
   * Set component's CSS 'justify-content' property.
   *
   * Use the object notation for a responsive layout (e.g. `{ mobile: 'start', tablet: 'center' }`).
   */
  justify: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(JUSTIFY_OPTS), (0, _responsiveProp.responsivePropType)(_propTypes2.default.oneOf(JUSTIFY_OPTS))]),

  /**
   * Set component's CSS 'align-items' property.
   *
   * Use the object notation for a responsive layout (e.g. `{ mobile: 'start', tablet: 'center' }`).
   */
  align: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(ALIGN_OPTS), (0, _responsiveProp.responsivePropType)(_propTypes2.default.oneOf(ALIGN_OPTS))]),

  /**
   * Gap in between children elements in main axis. Only applies to flexbox layouts
   * (i.e. "block" and "fit" layouts are exempt).
   */
  gap: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(GAP_OPTS), (0, _responsiveProp.responsivePropType)(_propTypes2.default.oneOf(GAP_OPTS))]),

  /**
   * Set component's CSS 'width' property.
   */
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),

  /**
   * Set component's CSS 'height' property.
   */
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

var defaultProps = exports.defaultProps = {};

function withLayout(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;

  /**
   * Higher Order Component that maps props to flexbox CSS styles. Also supports
   * explicit width and height.
   */
  var ComponentWithLayout = function ComponentWithLayout(props) {
    var layout = props.layout,
        wrap = props.wrap,
        flex = props.flex,
        justify = props.justify,
        align = props.align,
        gap = props.gap,
        width = props.width,
        height = props.height,
        className = props.className,
        style = props.style,
        children = props.children;

    var componentProps = _extends({}, props);

    // Create className prop.
    if (layout || wrap || flex || justify || align || className) {
      var classes = className;

      ['layout', 'wrap', 'flex', 'justify', 'align'].forEach(function (prop) {
        var responsiveMap = (0, _responsiveProp.normalizeResponsiveProp)(props[prop]);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(responsiveMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var breakpoint = _ref2[0];
            var value = _ref2[1];

            classes = (0, _classnames4.default)(classes, _defineProperty({}, styles['' + (0, _responsiveProp.breakpointPrefix)(breakpoint) + prop + toClassName(value)], value));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });

      componentProps.className = classes;
    }

    // Create style prop.
    if (width || height || style) {
      componentProps.style = Object.assign({}, { width: width, height: height }, style);
    }

    // Interleave spacers with children.
    if (gap) {
      var gapClasses = void 0;
      var gapResponsiveMap = (0, _responsiveProp.normalizeResponsiveProp)(gap);
      var layoutResponsiveMap = (0, _responsiveProp.normalizeResponsiveProp)(layout);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.entries(gapResponsiveMap)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = _slicedToArray(_ref3, 2);

          var breakpoint = _ref4[0];
          var value = _ref4[1];

          var layoutValue = layoutResponsiveMap[breakpoint];
          var spacingDirection = layoutValue === 'vertical' ? 'top' : 'left';
          gapClasses = (0, _classnames4.default)(gapClasses, _defineProperty({}, styles['' + (0, _responsiveProp.breakpointPrefix)(breakpoint) + spacingDirection + '-' + value], value));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var childrenArr = _react2.default.Children.toArray(children);
      componentProps.children = childrenArr.reduce(function (acc, child, i) {
        acc.push(child);
        if (i < childrenArr.length - 1) {
          acc.push(_react2.default.createElement('div', { className: gapClasses }));
        }
        return acc;
      }, []);
    }

    // Wether to forward or not layout props.
    if (!options.forwardLayoutProps) {
      ['layout', 'wrap', 'flex', 'align', 'justify', 'gap', 'width', 'height'].forEach(function (prop) {
        return delete componentProps[prop];
      });
    }

    return _react2.default.createElement(Component, componentProps);
  };

  ComponentWithLayout.displayName = 'withLayout(' + (Component.displayName || Component.name || '') + ')';
  ComponentWithLayout.propTypes = propTypes;
  ComponentWithLayout.defaultProps = defaultProps;

  return ComponentWithLayout;
}